import window from 'window-or-global';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

const referrerPlugin = () => {
	return {
		init(ed) {
			ed.on('Init', () => {
				const $form = $('#createpageform');
				const $originalReferrer = $form.find('#originalReferrer');

				//If we are creating a new page that doesn't already has a referrer set and we have one
				if ($form.length && !$originalReferrer.val() && document.referrer) {
					$originalReferrer.val(document.referrer);
				}
			});
		},

		getInfo() {
			return {
				longname: 'Confluence Cancel Return Url',
				author: 'Atlassian',
				authorurl: 'http://www.atlassian.com',
				version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
			};
		},
	};
};

export default function () {
	window.tinymce.create('tinymce.plugins.Referrer', referrerPlugin());
	window.tinymce.PluginManager.add('referrer', window.tinymce.plugins.Referrer);
}
